import React from 'react'
import PropTypes from 'prop-types'
import InputMask from 'react-input-mask';

import { TextField } from '../../default';

function MaskedField({ id, text, disabled, mask, onlyNumber, fkProps, ...rest }) {

  const handleChange = evt => {
    if (onlyNumber)
      evt.target.value = (evt.target.value || '').replace(/[^0-9]/g, '')

    if (!disabled)
      fkProps.handleChange(evt)
  }

  return (
    <InputMask
      mask={mask}
      value={fkProps.values[id]}
      onChange={handleChange}
      onBlur={fkProps.handleBlur}
      disabled={disabled}
      alwaysShowMask
    >
      {inputProps => (
        <TextField
          id={id}
          label={text}
          disabled={disabled}
          helperText={fkProps.touched[id] ? fkProps.errors[id] : ""}
          error={fkProps.touched[id] && Boolean(fkProps.errors[id])}          
          {...inputProps}
          {...rest}
        />
      )}
    </InputMask>
  )
}

MaskedField.propTypes = {
  id: PropTypes.string.isRequired,
  mask: PropTypes.string.isRequired,
  fkProps: PropTypes.object.isRequired,

  text: PropTypes.string,
  disabled: PropTypes.bool,
  onlyNumber: PropTypes.bool,
}

MaskedField.defaultProps = {
  text: '',
  disabled: false,
  onlyNumber: true,
}

export default MaskedField